import React from 'react';
import { XCircle, ArrowLeft, HelpCircle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function ExtensionCancel() {
  return (
    <div className="min-h-screen bg-[#0B1120] text-white">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-red-500/5 via-transparent to-slate-900/50 pointer-events-none" />
      
      <div className="relative max-w-2xl mx-auto px-6 py-20">
        {/* Cancel Icon */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-slate-800 border border-slate-700 mb-6">
            <XCircle className="w-12 h-12 text-slate-400" />
          </div>
          
          <h1 className="text-3xl font-bold mb-4">
            Payment Cancelled
          </h1>
          
          <p className="text-lg text-slate-400">
            No worries! Your card was not charged.
          </p>
        </div>

        {/* Info Card */}
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 mb-8">
          <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
            <HelpCircle className="w-5 h-5 text-slate-400" />
            What happened?
          </h3>
          <p className="text-slate-400 text-sm mb-4">
            You cancelled the checkout process before completing payment. 
            This could happen if you:
          </p>
          <ul className="text-sm text-slate-400 space-y-2 ml-4">
            <li>• Closed the payment window</li>
            <li>• Clicked the back button</li>
            <li>• Decided to think about it more</li>
          </ul>
        </div>

        {/* Still interested section */}
        <div className="bg-gradient-to-r from-[#FFD700]/10 to-[#FFA500]/5 border border-[#FFD700]/20 rounded-xl p-6 mb-8">
          <h3 className="text-lg font-semibold mb-2 text-[#FFD700]">
            Still interested in Premium?
          </h3>
          <p className="text-slate-400 text-sm mb-4">
            Get unlimited price comparisons, price alerts, and more for just $4.99/month.
          </p>
          <Button
            onClick={() => window.location.href = '/extension'}
            className="w-full bg-gradient-to-r from-[#FFD700] to-[#FFA500] hover:from-[#FFD700]/90 hover:to-[#FFA500]/90 text-[#0B1120] font-semibold"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Try Again
          </Button>
        </div>

        {/* Free features reminder */}
        <div className="bg-[#0E1426] border border-[#22304A] rounded-xl p-6 mb-8">
          <h3 className="text-lg font-semibold mb-4">Free Features Still Available</h3>
          <p className="text-slate-400 text-sm mb-4">
            You can still use Commerce Index with these free features:
          </p>
          <ul className="text-sm text-slate-300 space-y-2">
            <li className="flex items-center gap-2">
              <span className="text-[#3EF1C7]">✓</span>
              Price comparisons (up to 10/day)
            </li>
            <li className="flex items-center gap-2">
              <span className="text-[#3EF1C7]">✓</span>
              Social proof on products
            </li>
            <li className="flex items-center gap-2">
              <span className="text-[#3EF1C7]">✓</span>
              Google Shopping integration
            </li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4">
          <Button
            onClick={() => window.close()}
            className="flex-1 bg-[#3EF1C7] hover:bg-[#3EF1C7]/90 text-[#0B1120] font-semibold"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Shopping
          </Button>
          <Button
            onClick={() => window.open('mailto:support@commerceindex.com', '_blank')}
            variant="outline"
            className="flex-1 border-slate-600 text-slate-300 hover:bg-slate-800"
          >
            Contact Support
          </Button>
        </div>

        {/* Support link */}
        <p className="text-center text-sm text-slate-500 mt-8">
          Questions? <a href="mailto:support@commerceindex.com" className="text-[#3EF1C7] hover:underline">We're here to help</a>
        </p>
      </div>
    </div>
  );
}
